import { StyleSheet, Platform } from 'react-native';
import Colors from '../constants/Colors';

const CommonStyles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  safe: {
    flex: 1,
    backgroundColor: Colors.blue,
    // backgroundColor: 'orange',
    width: '100%',
  },
  container: {
    flex: 1,
    backgroundColor: Colors.blue,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 10,
    width: '100%',
    // backgroundColor: 'yellow',
  },
  innerContainer: {
    flex: 1,
    width: '100%',
    paddingHorizontal: 10,
    // alignItems: 'center',
    // flexGrow: 1,
    alignSelf: 'center',

    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
  },
  scrollViewStyle: {
    width: '100%',
    flex: 1,
    // marginVertical: 10,
  },
  scrollViewContentContainerStyle: {
    width: '100%',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    // justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf: 'center',
    // backgroundColor: 'pink',
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  flexWrap: {
    flex: 1,
    flexWrap: 'wrap',
  },
  responsiveImage: {
    width: '100%',
    height: undefined,
  },
  textInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    borderRadius: 10,
    borderColor: Colors.lightBlue,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: Colors.textInputBackground,
  },
  textInputContainerInvalid: {
    borderColor: Colors.invalid,
  },
  textInputContainerDisabled: {
    borderColor: Colors.mediumGrey,
    backgroundColor: Colors.lightGrey,
    ...Platform.select({
      web: {
        cursor: 'not-allowed',
      }
    })
  },
  textInput: {
    padding: 10,
    borderRadius: 10,
    backgroundColor: Colors.textInputBackground,
    color: Colors.lightText,
    fontSize: 18,
    flex: 1,
    maxWidth: '100%',
  },
  textInputDisabled: {
    color: Colors.mediumGrey,
    backgroundColor: Colors.lightGrey,
    ...Platform.select({
      web: {
        cursor: 'not-allowed',
      }
    })
  },
  inputIcon: {
    padding: 8,
    paddingRight: 0,
    alignSelf: 'center',
    textAlign: 'center',
    width: 32,
  },
  textInputInvalid: {
    color: Colors.invalid, 
  },
  passwordInputContainer: {
    width: '100%',
    marginBottom: 20,
  },
  buttonOuter: {
    width: '100%',
    flexDirection:'row',
  },
  button: {
    alignItems: 'center',
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    flex:1,
  },
  buttonText: {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: 12,
    fontSize: 20,
    fontWeight: 'bold'
  },
  buttons: {
    marginTop: 20,
  },
  buttonLeft: {
    marginRight: 5,
    flex: 1
  },
  buttonRight: {
    marginLeft: 5,
    flex: 1,
  },
  yellowText: {
    color: Colors.yellow,
  },
  lightText: {
    color: Colors.lightText,
  },
  greyText: {
    color: Colors.greyText,
  },
  mediumGreyText: {
    color: Colors.mediumGrey,
  },
  darkText: {
    color: Colors.darkGrey,
  },
  lightBlueText: {
    color: Colors.lightBlue2,
  },
  blueText: {
    color: Colors.blue,
  },
  greenText: {
    color: Colors.green,
  },
  neonGreenText: {
    color: Colors.neonGreen,
  },
  whiteText: {
    color: 'white',
  },
  redText: {
    color: 'red',
  },
  centerText: {
    textAlign: 'center',
  },
  rightText: {
    textAlign: 'right',
  },
  capsLock: {
    textTransform: 'uppercase',
  },
  italicText: {
    fontStyle: 'italic',
  },
  largeTitle: {
    fontSize: 36,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  mediumTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    marginVertical: 20
  },
  smallTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    marginVertical: 20,
  },
  miniText: {
    fontSize: 14,
  },
  smallText: {
    fontSize: 18,
  },
  mediumText: {
    fontSize: 22,
  },
  largeText: {
    fontSize: 26,
  },
  giantText: {
    fontSize: 32,
  },
  boldText: {
    fontWeight: 'bold',
  },
  heavyText: {
    ...Platform.select({
      ios: {
        fontWeight: '900',
      },
      web: {
        fontWeight: '900',
      },
      android: {
        fontWeight: 'bold',
      }
    }),
  },
  regularText: {
    fontWeight: '400',
  },
  lightWeightText: {
    ...Platform.select({
      ios: {
        fontWeight: '300',
      },
      web: {
        fontWeight: '300',
      },
      android: {
        fontFamily: 'sans-serif-light',
      }
    })
  },
  mediumWeightText: {
    ...Platform.select({
      ios: {
        fontWeight: '500',
      },
      web: {
        fontWeight: '500',
      },
      android: {
        fontFamily: 'sans-serif-medium',
      }
    })
  },
  noMargin: {
    margin: 0,
    marginVertical: 0,
    marginHorizontal: 0,
  },
  // tab buttons 3 or more buttons
  tabButton: {
    padding: 10,
    alignItems: 'center',
    flex: 1,
    borderWidth: 1,
    borderColor: Colors.lightBlue,
    backgroundColor: Colors.textInputBackground,
  },
  tabButtonActive: {
    backgroundColor: Colors.yellow,
    borderColor: Colors.yellow,
  },
  tabButtonLeft: {
    borderBottomLeftRadius: 10,
    borderTopLeftRadius: 10,
  },
  tabButtonCenter: {
    flex: 0,
  },
  tabButtonRight: {
    borderBottomRightRadius: 10,
    borderTopRightRadius: 10,
  },
  link: {
    borderBottomWidth: 1,
    borderColor: Colors.yellow,
    paddingBottom:2,
    color: Colors.yellow,
  },
  webModal: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderWidth: 0,
    zIndex: 1999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.85)',
  },
});

export default CommonStyles;